// extracted by mini-css-extract-plugin
export default {"Container":"LiveStreamCardItem_Container__kTbwn","Body":"LiveStreamCardItem_Body__2OnTS","Info":"LiveStreamCardItem_Info__e7WQg"};